<template>
  <div>
    <MainNavBarWapV2 :object-data="infoHeader" />
    <!-- desktop >768px md -->
    <div class="desktop ">
      <el-row style="margin: auto;" class="full-width container top-spacing">
        <el-col :xs="24" :sm="13" :md="13" :lg="13">
          <div class="banner-facility">
            <img
              class="full-width banner-facility"
              src="https://web-api.vcallid.com/static/uploads/e97e2bba-bc46-45c2-b085-1e7fa8894911.png"
              alt=""
            />
          </div>
          <div class="contact-container ">
            <h3 class="facility-name">Tam Đảo Golf</h3>
            <div class="detail-contact-container">
              <img :src="icons.AddressBrownIcon" alt="" />
              <p class="text-contact">Vĩnh Phúc, Hà Nội</p>
            </div>
            <div class="detail-contact-container">
              <img :src="icons.PhoneIcon" alt="" />
              <p class="text-contact">0243 567 890</p>
            </div>
            <div class="detail-contact-container">
              <img :src="icons.SocialIcon" alt="" />
              <p class="text-contact">www.tamdaogolf.com</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="10" :md="10" :lg="10">
          <div class="describe-container px-15">
            <h3 class="facility-name m-0">Mô tả</h3>
            <p
              :class="{ 'hide-content': !isShowContent }"
              class="describe-facility c-black-text "
            >
              Đầu mùa giải năm ngoái links courses, Maidstone is also one of the
              country’s earliest golf residential communities. Legend has it
              that Bobby Jones felt that Maidstone’s final three holes made it
              one of the great match-play courses in America. If so, that’s
              because the 17th has one of the tightest green sites in America,
              the green sitting just in front of a major street intersection,
              with roads right and left less
            </p>
            <p @click="onShowContent" class="see-more c-inherit-text">
              {{ more }}
            </p>
          </div>
          <div class="divider-view"></div>
          <div class="policy-facility px-15 mb-20">
            <h3 class="facility-name">Chính sách của sân</h3>
            <div class="flex">
              <div class="flex">
                <img class="mr-10" :src="icons.NotedIcon" alt="" />
                <p class="m-0 c-black-text">Một số yêu cầu của sân</p>
              </div>
              <img :src="icons.ArrowRightIcon" alt="" />
            </div>
          </div>
          <div class="px-15">
            <button
              @click="$router.push('/wap/booking')"
              class="btn-submit bg-btn-main c-white-text full-width"
            >
              {{ $t("setUpTheYardQuickly") }}
            </button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- end of desktop -->

    <!-- mobile <768px xs-->
    <div class="mobile">
      <div style="padding-top: 60px;" class="full-width px-15 ">
        <div
          style="overflow: hidden;"
          class="btn-insurance-container mb-20 flex justify-content-center"
        >
          <button
            @click="() => (this.isActive = 0)"
            :class="{
              'c-white-text bg-btn-main': isActive === 0
            }"
            class="c-inherit-text"
            style="width:100%;padding:3px;"
          >
            Chứng nhận bảo hiểm
          </button>
          <button
            @click="() => (this.isActive = 1)"
            :class="{
              'c-white-text bg-btn-main': isActive === 1
            }"
            class="c-inherit-text"
            style="width:100%;"
          >
            Danh sách
          </button>
        </div>
        <div v-if="isActive === 0">
          <div class="flex justify-content-center mb-20">
            <img :src="icons.HIOIcon" alt="" />
            <div class="ml-20 mr-20"></div>
            <img :src="icons.PIVIcon" alt="" />
          </div>
          <div class="mb-20">
            <h3 class="text-align-center c-rather-text c-body2 m-0 ">
              GIẤY CHỨNG NHẬN <br />
              BẢO HIỂM BỒI THƯỜNG GIẢI THƯỞNG (GOLF)
            </h3>
            <div class="mt-10 content">
              <div class="flex justify-content-space-between mb-10">
                <p class="m-0 flex-shrink-0 mr-20 c-span-text">Người mua</p>
                <p class="m-0 c-black-text c-medium-text">
                  CÔNG TY CỔ PHẦN DỊCH VỤ ĐẶT SÂN GOLF VIỆT NAM
                </p>
              </div>
              <div class="flex justify-content-space-between mb-10">
                <p class="m-0 flex-shrink-0 mr-20 c-span-text">Địa chỉ</p>
                <p class="m-0 c-medium-text">
                  Số 214 Lạc Long Quân, Bưởi, Tây Hồ
                </p>
              </div>
              <div class="flex justify-content-space-between mb-10">
                <p class="m-0 flex-shrink-0 mr-20 c-span-text">Số điện thoại</p>
                <p class="m-0 c-medium-text">
                  0855 846 568
                </p>
              </div>
              <div class="flex justify-content-space-between mb-10">
                <p class="m-0 flex-shrink-0 mr-20 c-span-text">Giải thi đấu</p>
                <p class="m-0 c-medium-text">
                  Giải golf tranh cup 16
                </p>
              </div>
              <div class="flex justify-content-space-between mb-10">
                <p class="m-0 flex-shrink-0 mr-20 c-span-text">Mã bảo hiểm</p>
                <p class="m-0 c-medium-text">
                  BH01019
                </p>
              </div>
              <div class="flex justify-content-space-between mb-10">
                <p class="m-0 flex-shrink-0 mr-20 c-span-text">Địa điểm:</p>
                <p class="m-0 c-medium-text">
                  Sân golf Tân Sơn Nhất
                </p>
              </div>
              <div class="flex justify-content-space-between mb-10">
                <p class="m-0 flex-shrink-0 mr-20 c-span-text">
                  Phạm vi bảo hiểm
                </p>
                <p class="m-0 c-medium-text">
                  Bồi thường cho người đươc bảo hiểm trách nghiệm phải trả cho
                  giải thưởng Son tint trị giá 100.000 VNĐ cho người thi đấu
                  thắng giải
                </p>
              </div>
              <div class="flex justify-content-space-between mb-10">
                <p class="m-0 flex-shrink-0 mr-20 c-span-text">
                  Thời gian thi đấu
                </p>
                <p class="m-0 c-medium-text">
                  16:00 30/11/2023
                </p>
              </div>
              <div class="flex justify-content-space-between mb-10">
                <p class="m-0 flex-shrink-0 mr-20 c-span-text">
                  Số lượng người:
                </p>
                <p class="m-0 c-medium-text">
                  Từ 3 Người/ ngày thi đấu
                </p>
              </div>
              <div class="flex justify-content-space-between mb-10">
                <p class="m-0 flex-shrink-0 mr-20 c-span-text">Lỗ golf hố:</p>
                <p class="m-0 c-medium-text">
                  Hố golf số 6B
                </p>
              </div>
              <div class="flex justify-content-space-between mb-10">
                <p class="m-0 flex-shrink-0 mr-20 c-span-text">
                  Thời hạn bảo hiểm
                </p>
                <p class="m-0 c-medium-text">
                  00:00 : 25/07- 23:59 27/07/2023
                </p>
              </div>
              <div class="flex justify-content-space-between mb-10">
                <p class="m-0 flex-shrink-0 mr-20 c-span-text">
                  Giá trị giải thưởng
                </p>
                <p class="m-0 c-medium-text">
                  Trị giá 100.000đ/PAX
                </p>
              </div>
              <div class="flex justify-content-space-between mb-10">
                <p class="m-0 flex-shrink-0 mr-20 c-span-text">Tỷ lệ phí</p>
                <p class="m-0 c-medium-text">
                  4.0 % (chưa bao gồm thuế GTGT)
                </p>
              </div>
            </div>
          </div>
          <div class="ml-20 mb-20">
            <ul>
              <li class="mb-10">
                <span class="c-rather-text">Điều khoản bảo hiểm: </span>
                <span class="c-span-text">
                  Theo Quy tắc bảo hiểm bồi thường giải thưởng gôn "Hole in one"
                  ban hành kèm theo Quyết định số 1269 /QĐ PVIBH ngày 31 tháng
                  12 năm 2013 của Tổng giám đốc Tổng công ty Bảo hiểm PVI
                </span>
              </li>
              <li class="mb-10">
                <span class="c-rather-text">Quyền tài phán: </span>
                <span class="c-span-text">Việt Nam</span>
              </li>
              <li class="mb-10">
                <span class="c-rather-text ">Giới hạn lãnh thổ: </span>
                <span class="c-span-text">Việt Nam</span>
              </li>
              <li class="mb-10">
                <span class="c-rather-text "> Điều khoản thanh toán: </span>
                <span class="c-span-text">
                  Thanh toán một (01) lần phí bảo hiểm bằng tiền mặt hoặc chuyển
                  khoản trước ngày 25/07/2023.
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="isActive === 1">
          <table>
            <tr class="c-tiny">
              <th>STT</th>
              <th>Họ tên</th>
              <th>Ngày sinh</th>
            </tr>
            <tr class="text-align-center c-tiny">
              <td class="text-align-center">1</td>
              <td>Nguyễn Đức Bình</td>
              <td>29/10/2001</td>
            </tr>
            <tr class="text-align-center c-tiny">
              <td class="text-align-center">1</td>
              <td>Nguyễn Đức Bình</td>
              <td>29/10/2001</td>
            </tr>
            <tr class="text-align-center c-tiny">
              <td class="text-align-center">1</td>
              <td>Nguyễn Đức Bình</td>
              <td>29/10/2001</td>
            </tr>
            <tr class="text-align-center c-tiny">
              <td class="text-align-center">1</td>
              <td>Nguyễn Đức Bình</td>
              <td>29/10/2001</td>
            </tr>
          </table>

          <div class="mt-20">
            <p class="c-tiny text-align-center m-0 c-medium-text">
              Cấp bởi: Công ty Bảo hiểm PVI Khánh Hòa
            </p>
            <p class="c-tiny text-align-center c-span-text m-0">
              Địa chỉ: 16A Tô Hiến Thành, P Tân Lập, TP. Nha Trang, tỉnh Khánh
              Hòa ĐT: 0258.3516671; 0258.3516672 Fax: 0258.3516673
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainNavBarWapV2 from "../../../../layout/WapV2/MainNavBar.vue";
import GolfIcon from "@/assets/img/svg/golf-icon.svg";
import PhoneIcon from "@/assets/img/svg/phone-icon.svg";
import SocialIcon from "@/assets/img/svg/social-icon.svg";
import AddressBrownIcon from "@/assets/img/svg/address-brown-icon.svg";
import NotedIcon from "@/assets/img/svg/noted-icon.svg";
import ArrowRightIcon from "@/assets/img/svg/arrow-right-icon.svg";
import PIVIcon from "@/assets/img/svg/W_PIV.svg";
import HIOIcon from "@/assets/img/svg/W_HIO.svg";

import { getBackGround } from "../../../../utils/wapAuth";

export default {
  components: {
    MainNavBarWapV2
  },
  bodyClass: "insurance-certificate",
  props: {},

  created() {},
  data() {
    return {
      isShowContent: false,
      more: "Xem thêm...",
      tableData: [
        {
          name: "Nguyễn Văn A",
          vid: "105581",
          hio: "HIO D20"
        },
        {
          hio: "HIO D20",
          name: "Nguyễn Văn A",
          vid: "105581"
        },
        {
          hio: "HIO D20",
          name: "Nguyễn Văn A",
          vid: "105581"
        }
      ],
      formRequest: {},
      rules: {},
      isActive: 0,
      listTimeTee: [],
      infoHeader: {
        title: "Giấy chứng nhận bảo hiểm",
        isShowHomeIcon: false
      },
      address: ["Tất cả", "Miền Bắc", "Miền Trung", "Miền Nam"],
      bg: getBackGround(),

      icons: {
        GolfIcon,
        AddressBrownIcon,
        SocialIcon,
        PhoneIcon,
        NotedIcon,
        ArrowRightIcon,
        PIVIcon,
        HIOIcon
      }
    };
  },
  mounted() {
    // Populate listTimeTee with translated values
    this.listTimeTee = [
      this.$t("morning"),
      this.$t("afternoon"),
      this.$t("evening")
    ];
  },
  watch: {},
  methods: {
    onShowContent: function() {
      this.more = this.isShowContent ? "Xem thêm..." : "Rút gọn";
      this.isShowContent = !this.isShowContent;
    },
    indexMethod(index) {
      return index + 1;
    },
    handleFilter(val) {
      this.isActive = val;
    }
  }
};
</script>
<style></style>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  border-style: hidden; /* hide standard table (collapsed) border */
  box-shadow: 0 0 0 1px rgba(215, 215, 215, 1); /* this draws the table border  */
}

th,
td {
  padding: 0.5em;
  border: 1px solid rgba(215, 215, 215, 1);
}
.content {
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
}
.btn-insurance-container {
  min-height: 24px;
  border: 1px solid v-bind("bg.c_inherit_text");
  border-radius: 100px;
}
.px-15 {
  padding: 0 15px;
}

.divider-view {
  height: 10px !important;
  width: 100%;
  background-color: #e3e3e3;
  margin: 30px 0;
}

.top-spacing {
  padding-top: 100px;
}

.divider-view {
  height: 1px;
  width: 100%;
  margin-bottom: 10px;
  background-color: #ececec;
}

.px-20 {
  padding-left: 20px;
  padding-right: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mr-10 {
  margin-right: 10px;
}

.ml-10 {
  margin-left: 10px;
}
.ml-20 {
  margin-left: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-20 {
  margin-right: 20px;
}
.ml-4 {
  margin-left: 4px;
}
.flex-grow {
  flex-grow: 1;
}

.pt-12 {
  padding-top: 12px;
}
.pb-0 {
  margin-bottom: 0px;
}
.pb-80 {
  padding-bottom: 80px;
}
.mt-36 {
  margin-top: 36px;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
}
</style>

<style lang="scss">
$divider-color: #d9d9d9;

.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.uppercase {
  text-transform: uppercase;
}
.full-width {
  width: 100%;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>
